var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0993 9.56383L17.665 11.998L20.0993 14.4323L22.5335 11.998L20.0993 9.56383Z",
    fill: "#1C1917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90199 9.56578L1.46777 12L3.90199 14.4342L6.3362 12L3.90199 9.56578Z",
    fill: "#1C1917"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.6659L7.965 13.6309L5.53125 16.0646L12 22.5334L18.4688 16.0646L16.035 13.6309L12 17.6659Z",
    fill: "#1C1917"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.3343L16.035 10.3693L18.4688 7.93555L12 1.4668L5.53125 7.93555L7.965 10.3693L12 6.3343Z",
    fill: "#1C1917"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 9.59628L9.59473 12L11.9984 14.4037L14.4022 12L11.9984 9.59628Z",
    fill: "#1C1917"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.708653bf54ef5848756fe2f1f4f1b646.svg";
export { ForwardRef as ReactComponent };